import React from "react";
import { Star } from "lucide-react";

export default function Reviews({ t }) {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative overflow-hidden bg-[#1A1A1A] py-24 text-[#F5F2EB] sm:py-32"
    >
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="mb-16 max-w-3xl">
          <p
            data-testid="reviews-eyebrow"
            className="mb-6 font-body text-xs uppercase tracking-[0.4em] text-[#A63D2F]"
          >
            — {t.reviews.eyebrow}
          </p>
          <h2
            data-testid="reviews-title"
            className="font-serif-display text-5xl leading-[1.05] text-[#F5F2EB] sm:text-6xl"
          >
            {t.reviews.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-x-12 gap-y-14 md:grid-cols-2">
          {t.reviews.items.map((rev, i) => (
            <figure
              key={i}
              data-testid={`review-${i}`}
              className="border-l border-[#F5F2EB]/20 pl-8"
            >
              <div className="mb-4 flex gap-1 text-[#A63D2F]">
                {Array.from({ length: 5 }).map((_, k) => (
                  <Star
                    key={k}
                    className="h-3.5 w-3.5"
                    fill="currentColor"
                    strokeWidth={0}
                  />
                ))}
              </div>
              <blockquote className="font-serif-display text-2xl italic leading-snug text-[#F5F2EB] sm:text-3xl">
                &ldquo;{rev.text}&rdquo;
              </blockquote>
              <figcaption className="mt-6 font-body text-xs uppercase tracking-[0.3em] text-[#EAE4D9]/70">
                — {rev.name}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
